/**
 * Loading priority for the Athos result grids (PLP + search).
 *
 * The grid is client-rendered, so the preload scanner never sees these images.
 * The best available substitute is to hand the first row real `src`/`srcset` the
 * moment Preact paints it, rather than waiting a LazyLoad IntersectionObserver
 * tick after that paint.
 */

/**
 * Cards in the first grid row — the only ones that can be on screen at first
 * paint. Columns are 2 below md, 3 from md, and `gridCols` (3 or 4) from lg.
 * Widening this past one row dilutes `fetchpriority` and re-creates the
 * front-loading it is meant to remove.
 */
export function getPriorityCardCount(gridCols: number): number {
  if (typeof window === 'undefined') return 2
  if (window.matchMedia('(min-width: 1024px)').matches) return gridCols
  if (window.matchMedia('(min-width: 768px)').matches) return 3
  return 2
}

/**
 * Media conditions matching the grid's real column widths. `ResultImage`
 * defaults to `50vw`, which is right for the 2-column mobile grid but roughly
 * double the box from md up — so the browser picks a candidate one step too
 * large on every desktop card.
 */
export function getGridImageSizes(gridCols: number): string {
  const desktopWidth = gridCols === 4 ? 25 : 33
  return `(min-width: 1024px) ${desktopWidth}vw, (min-width: 768px) 33vw, 50vw`
}
